import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "@/App";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error("Authentication failed");
        navigate('/login');
        return;
      }

      try {
        // Exchange session_id for user data
        const response = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        login(response.data);
        toast.success(`Welcome${response.data.name ? ', ' + response.data.name : ''}!`);

        // Check if user has profile
        const meResponse = await axios.get(`${API}/auth/me`);
        if (meResponse.data.has_profile) {
          navigate('/dashboard', { state: { user: response.data } });
        } else {
          navigate('/onboarding', { state: { user: response.data } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error("Authentication failed. Please try again.");
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#FFFBF0] flex items-center justify-center">
      <div className="text-center">
        <div className="w-20 h-20 rounded-full hero-gradient flex items-center justify-center mx-auto mb-6 animate-pulse-soft">
          <Heart className="w-10 h-10 text-white" fill="white" />
        </div>
        <h2 className="text-2xl font-bold text-slate-800 mb-2" style={{ fontFamily: 'Fredoka, sans-serif' }}>
          Signing you in...
        </h2>
        <p className="text-slate-600">Just a moment while we set things up</p>
        <div className="mt-6">
          <div className="w-48 h-2 bg-slate-200 rounded-full mx-auto overflow-hidden">
            <div className="h-full bg-sky-500 rounded-full animate-pulse" style={{ width: '60%' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;